<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="assets"
      :loading="loading"
      item-key="id"
      no-data-text="Không có thiết bị nào"
      :server-items-length="totalItems"
      :footer-props="{
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page-options': [10, 20, 50]
      }"
      @update:options="onOptionsChange"
    >
      <template v-slot:item.code="{ item }">
        <a class="primary--text" @click="onViewDetail(item)">{{ item.code }}</a>
      </template>

      <template v-slot:item.category="{ item }">
        <span>{{ get(item, 'category.name', '-') }}</span>
      </template>

      <template v-slot:item.location="{ item }">
        <span>{{ get(item, 'location.name', '-') }}</span>
      </template>

      <template v-slot:item.unit="{ item }">
        <span>{{ item.unit || '-' }}</span>
      </template>

      <template v-slot:item.quantities="{ item }">
        <span>
          {{ item.availableQuantity }} / {{ item.quantity }}
        </span>
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip small :color="item.status | assetStatusColor" dark>
          {{ item.status | assetStatus }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon small color="primary" class="mr-1" @click="onViewDetail(item)" title="Xem chi tiết thiết bị">
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
        <v-btn icon small color="indigo" class="mr-1" @click="onPrintBarcode(item)" title="Xem & In mã QR">
          <v-icon small>mdi-qrcode</v-icon>
        </v-btn>
        <v-btn icon small color="primary" class="mr-1" @click="onEdit(item)" title="Sửa thiết bị">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon small color="error" @click="onRemove(item)" title="Xóa thiết bị">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Dialog xem chi tiết, sửa & In QR -->
    <AssetDetailDialog :state="detailDialog" :item="selectedItem" @open-edit="onEdit" @open-barcode="onPrintBarcode" />
    <AssetEditDialog :state="editDialog" :asset-data="selectedItem" @updated="refresh()" />
    <AssetBarcodeDialog :state="barcodeDialog" :item="selectedItem" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import AssetDetailDialog from '@/modules/facility/asset/AssetDetailDialog.vue'
import AssetEditDialog from '@/modules/facility/asset/AssetEditDialog.vue'
import AssetBarcodeDialog from '@/modules/facility/asset/AssetBarcodeDialog.vue'

const headers = [
  { text: 'Mã Barcode', value: 'code', align: 'left', sortable: false },
  { text: 'Tên thiết bị', value: 'name', align: 'left', sortable: false },
  { text: 'Đầu mục', value: 'category', align: 'left', sortable: false },
  { text: 'Vị trí', value: 'location', align: 'left', sortable: false },
  { text: 'Đơn vị', value: 'unit', align: 'center', sortable: false },
  { text: 'Khả dụng / Tổng', value: 'quantities', align: 'center', sortable: false },
  { text: 'Trạng thái', value: 'status', align: 'center', sortable: false },
  { text: 'Thao tác', value: 'actions', align: 'center', sortable: false, width: '160px' }
]

export default {
  name: 'AssetDataTable',
  components: {
    AssetDetailDialog,
    AssetEditDialog,
    AssetBarcodeDialog
  },
  data() {
    return {
      headers,
      detailDialog: false,
      editDialog: false,
      barcodeDialog: false,
      selectedItem: null
    }
  },
  computed: {
    ...mapState('FacilityAssets', ['assets', 'totalItems', 'pageText', 'loading'])
  },
  methods: {
    get,
    ...mapActions('FacilityAssets', ['requestPageSettings', 'searchAssetList', 'removeAsset']),
    async refresh(query) {
      this.searchAssetList(query || {})
    },
    onOptionsChange({ page, itemsPerPage }) {
      this.requestPageSettings({ page, itemsPerPage })
    },
    onViewDetail(item) {
      this.selectedItem = item
      this.detailDialog = !this.detailDialog
    },
    onPrintBarcode(item) {
      this.selectedItem = item
      this.barcodeDialog = !this.barcodeDialog
    },
    onEdit(item) {
      this.selectedItem = item
      this.editDialog = !this.editDialog
    },
    onRemove(item) {
      this.$dialog.confirm({
        title: 'Thông báo xác nhận',
        text: `Bạn có chắc muốn xóa thiết bị "${item.name}"?`,
        okText: 'Xóa',
        cancelText: 'Hủy',
        done: async () => {
          this.$loading.active = true
          try {
            await this.removeAsset(item.id)
            this.$alert.deleteSuccess()
          } catch (error) {
            this.$alert.deleteError(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
